<template>
  <div class="infoOther">
    <div>
      <div>
        <div class="bl">
          合作保险机构情况
        </div>
        <div class="company">
          <div class="company-header fz16">
            <p class="company-title"><span>合作机构名称<br>（标准全称）</span></p>
            <p class="company-area"><span>业务合作范围</span></p>
            <p class="company-time"><span>合作起止时间</span></p>
            <p class="company-link"><span>官网地址</span></p>
            <p class="company-tell"><span>统一客服电话</span></p>
          </div>
          <ul class="company-list fz12">
            <li class="company-header organTable" v-for="item in cooperations" :key="item.id">
              <p class="company-title"><span>{{item.title}}</span></p>
              <p class="company-area"><span>{{item.area}}</span></p>
              <p class="company-time"><span>{{item.time}}</span></p>
              <p class="company-link"><span>{{item.link}}</span></p>
              <p class="company-tell"><span>{{item.phone}}</span></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- <div class="colorTitle" style="margin-top:60px;">
      互联网保险产品在售清单
    </div>
    <div style="margin-top:30px;">
      <a :href="lineListUrl" target="_blank"
        style="color:#FE7B28;">互联网保险产品在售清单</a>
    </div>
    <div class="colorTitle" style="margin-top:30px;">
      相关监管评价信息
    </div>
    <div>暂无</div>

    <div class="colorTitle" style="margin-top:30px;">
      涉及互联网保险业务开展的公司经营变化情况
    </div>
    <div>暂无</div> -->
    
      
  </div>
</template>

<script>
  export default {
    name: 'infoOther',
    components: {},
    data() {
      return {
        cooperations: [
          {id:'1',title:'	君康人寿保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.jklife.com/',phone:'956016'},
          {id:'2',title:'	信泰人寿保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.xintai.com/',phone:'95365'},
          {id:'3',title:'	工银安盛人寿保险有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.icbc-axa.com/index.jsp',phone:'95359'},
          {id:'4',title:'	瑞泰人寿保险有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.oldmutual-guodian.com/',phone:'95795166'},
          {id:'5',title:'	富德生命人寿保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.sino-life.com/',phone:'95535'},
          {id:'6',title:'	中意人寿保险有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.generalichina.com/',phone:'4008889888'},
          {id:'7',title:'	中韩人寿保险有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.sinokorealife.com.cn/',phone:'4009800800'},
          {id:'8',title:'	百年人寿保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.aeonlife.com/',phone:'95542'},
          {id:'9',title:'	英大泰和人寿保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'http://www.ydthlife.com/index.shtml',phone:'4000188688'},
          {id:'10',title:'	和谐健康保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://www.hexiehealth.com/',phone:'956076'},
          {id:'11',title:'	阳光人寿保险股份有限公司',area:'	人身险业务',time:'2022.1.1-2022.12.31',link:'https://life.sinosig.com/#/index/Index',phone:'95510'},
        ],
        lineListUrl: ''
      }
    },
    computed: {},
    created() {
      const num = Math.round(Math.random() * 100000)
      this.lineListUrl = `https://img.baoxianxia.com.cn/%E6%8A%AB%E9%9C%B2%E4%BA%A7%E5%93%81%E6%83%85%E5%86%B5.pdf?${num}`
    },
    mounted() {},
    methods: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .infoOther {
    width: 876px;
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.1);
    padding: 40px;

    .recruitText{
      line-height: 30px;
    }

    .company {
      margin-top: 20px;
      font-size: 14px;
    }

    .company-header {
      background: #EBEBEB;
      min-height: 50px;
      font-weight: 600;
      color: #333;
      letter-spacing: 1px;
      line-height: 1.5;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }

    p {
      height: 50px;
      border: 1px solid #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        display: inline-block;
      }
    }

    .company-title {
      width: 130px;
      padding-left: 10px;
    }

    .company-area {
      width: 130px;
      padding-left: 10px;
    }

    .company-time {
      width: 160px;
      padding-left: 10px;
    }

    .company-link {
      width: 300px;
      padding-left: 10px;
      word-break:break-all;
    }

    .company-tell {
      width: 130px;
      padding-left: 10px;
    }

    .company-list {
      .company-header {
        background-color: #ffffff;
        font-weight: normal;
      }
    }
  }
</style>